/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * UpSmith Dev API
 * OpenAPI spec version: 1.0.0
 */

export type ImagePurpose = (typeof ImagePurpose)[keyof typeof ImagePurpose];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImagePurpose = {
  competition_cover: "competition_cover",
  competition_prize: "competition_prize",
  profile: "profile",
  feed: "feed",
} as const;
